import { render, staticRenderFns } from "./PersonalLoanSelection.vue?vue&type=template&id=c1242b9e"
import script from "./PersonalLoanSelection.vue?vue&type=script&lang=js"
export * from "./PersonalLoanSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports